import { DataFileInterface } from '@systemeio/file-manager'
import {
  ProductOptionInterface,
  ProductOptionValueInterface,
} from 'modules/products/types/product-option-interface'
import { ProductVariantInterface } from 'modules/products/types/product-variant-interface'
import { ulid } from 'ulid'

function calculateOptionValuesIntersections(arr: ProductOptionValueInterface[][]) {
  if (arr.length) {
    return arr.reduce(
      (a, b) => {
        return a
          .map(x => b.map(y => x.concat([y])))
          .reduce((a, b) => {
            return a.concat(b)
          }, [])
      },
      [[]] as ProductOptionValueInterface[][],
    )
  }
  return []
}

const areArraysIntersected = (needle: string[], haystack: string[]) => {
  return needle.every(value => haystack.includes(value))
}

export function getVariants(
  options: ProductOptionInterface[],
  oldVariants?: ProductVariantInterface[],
  //needed for first iteration when we have not full data from backend
  fromBackend = false,
): ProductVariantInterface[] {
  if (!options.length) return []
  const filteredOptionValues = options.reduce((acc, option) => {
    const filteredOptionValues = option.optionValues.filter(optionValue => !!optionValue.value)
    if (!!filteredOptionValues.length) {
      acc.push(filteredOptionValues)
    }
    return acc
  }, [] as ProductOptionValueInterface[][])

  const calculatedOptionsValuesIntersections =
    calculateOptionValuesIntersections(filteredOptionValues)

  const variantsWithPreviousValues = calculatedOptionsValuesIntersections.map(optionsValues => {
    const optionValueIds = optionsValues.map(e => e.id)

    const matchedOldVariant = oldVariants?.find(oldVariant => {
      const oldOptionValueIds = oldVariant.optionValueIds

      if (optionValueIds.length === oldOptionValueIds.length) {
        return areArraysIntersected(optionValueIds, oldOptionValueIds)
      } else if (optionValueIds.length > oldOptionValueIds.length) {
        return areArraysIntersected(oldOptionValueIds, optionValueIds)
      } else return areArraysIntersected(optionValueIds, oldOptionValueIds)
    })

    const calculatedSku = `${optionsValues
      ?.map(e => e.value)
      .join('')
      .substring(0, 3)
      .toUpperCase()}-${Math.floor(Math.random() * 1000)}`

    //regenerate sku when option value was added or removed else keep it the same
    const skuNeedToBeRegenerated =
      matchedOldVariant?.optionValueIds.length !== optionValueIds.length

    return {
      id: matchedOldVariant?.id || ulid(),
      optionValueIds: optionValueIds,
      productOptionValues: optionsValues,
      sku: skuNeedToBeRegenerated ? calculatedSku : matchedOldVariant?.sku,
      selected: matchedOldVariant?.selected || false,
      deleted: fromBackend
        ? matchedOldVariant
          ? false
          : true
        : matchedOldVariant?.deleted || false,
      price: matchedOldVariant?.price || undefined,
      image: matchedOldVariant?.image,
      stock: matchedOldVariant?.stock,
    }
  })

  return variantsWithPreviousValues
}

export const getFilteredVariantsImagesList = (variants: ProductVariantInterface[]) => {
  const variantsImages = variants
    .map(variant => variant.image)
    .filter(Boolean) as DataFileInterface[]

  const filteredList = variantsImages.reduce((acc, curr) => {
    const isDuplicate = acc.find(image => image.id === curr.id)
    if (isDuplicate) {
      return acc
    } else {
      acc.push(curr)
      return acc
    }
  }, [] as DataFileInterface[])

  return filteredList
}
